export namespace AkaunShellConstants {
  export enum WINDOW_POST_MSG_TYPE {
    CHANGE_EMAIL_SUCCESS = 'CHANGE_EMAIL_SUCCESS',
    CHANGE_MOBILE_NUMBER_SUCCESS = 'CHANGE_MOBILE_NUMBER_SUCCESS',
    ADD_EMAIL_SUCCESS = 'ADD_EMAIL_SUCCESS',
    ADD_MOBILE_NUMBER_SUCCESS = 'ADD_MOBILE_NUMBER_SUCCESS',
  }

  export enum QUERY_PARAMS {
    PREV_STATE = 'prev_state'
  }

  export enum PREV_STATE_VALUES {
    LOGIN = 'login'
  }
}
